import { ProfilePremiumDialog } from './profile-premium-dialog';
import { DIALOG } from '../dialog-combiner';
import { transitions } from '../transition.config';
import { userModals } from 'core/User/modal.config';

DIALOG.add(userModals.PROFILE_PREMIUM, {
  component: ProfilePremiumDialog,
  transition: transitions.SHOW_NAV,
  anchor: 'portal',
});
